var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            'use strict';
            var DashboardController = (function () {
                function DashboardController() {
                }
                return DashboardController;
            }());
            dashboard.DashboardController = DashboardController;
            var Dashboard = (function () {
                function Dashboard() {
                    this.templateUrl = 'src/dashboards/dashboard/dashboard.html';
                    this.restrict = 'E';
                    this.transclude = true;
                    this.replace = true;
                    this.bindToController = true;
                    this.controller = DashboardController;
                    this.controllerAs = 'dbCtrl';
                    this.scope = {
                        'dashboardTitle': '<'
                    };
                }
                Dashboard.Factory = function () {
                    var directive = function () {
                        return new Dashboard();
                    };
                    return directive;
                };
                return Dashboard;
            }());
            dashboard.Dashboard = Dashboard;
            angular.module('bm.core.dashboard.Dashboard', [])
                .directive('dashboard', Dashboard.Factory());
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=dashboard.js.map
var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            'use strict';
            var DashboardWidgetController = (function () {
                function DashboardWidgetController() {
                }
                return DashboardWidgetController;
            }());
            dashboard.DashboardWidgetController = DashboardWidgetController;
            var DashboardWidget = (function () {
                function DashboardWidget($compile, $timeout, $translate) {
                    this.$compile = $compile;
                    this.$timeout = $timeout;
                    this.$translate = $translate;
                    this.templateUrl = 'src/dashboards/dashboard/dashboard-widget.html';
                    this.restrict = 'E';
                    this.transclude = true;
                    this.replace = true;
                    this.bindToController = true;
                    this.controller = DashboardWidgetController;
                    this.controllerAs = 'dbwCtrl';
                    this.scope = {
                        'dashboardWidgetTitle': '<'
                    };
                    this.link = function (scope, element, attrs, ctrl, transclude) {
                        $timeout(function () {
                            var footer = element[0].querySelector('footer');
                            if (footer) {
                                footer.classList.add('bm-widget-footer');
                            }
                        });
                    };
                }
                DashboardWidget.Factory = function () {
                    var directive = function ($compile, $timeout, $translate) {
                        return new DashboardWidget($compile, $timeout, $translate);
                    };
                    directive['$inject'] = ['$compile', '$timeout', '$translate'];
                    return directive;
                };
                return DashboardWidget;
            }());
            dashboard.DashboardWidget = DashboardWidget;
            angular.module('bm.core.dashboard.DashboardWidget', []).directive('dashboardWidget', DashboardWidget.Factory());
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=dashboard-widget.js.map
var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            'use strict';
            var DashboardSectionController = (function () {
                function DashboardSectionController() {
                }
                return DashboardSectionController;
            }());
            dashboard.DashboardSectionController = DashboardSectionController;
            var DashboardSection = (function () {
                function DashboardSection($compile, $timeout, $translate) {
                    this.$compile = $compile;
                    this.$timeout = $timeout;
                    this.$translate = $translate;
                    this.templateUrl = 'src/dashboards/dashboard/dashboard-section.html';
                    this.restrict = 'E';
                    this.transclude = true;
                    this.replace = true;
                    this.bindToController = true;
                    this.controller = DashboardSectionController;
                    this.controllerAs = 'dbsCtrl';
                    this.scope = {
                        'dashboardSectionTitle': '<'
                    };
                }
                DashboardSection.Factory = function () {
                    var directive = function ($compile, $timeout, $translate) {
                        return new DashboardSection($compile, $timeout, $translate);
                    };
                    directive['$inject'] = ['$compile', '$timeout', '$translate'];
                    return directive;
                };
                return DashboardSection;
            }());
            dashboard.DashboardSection = DashboardSection;
            angular.module('bm.core.dashboard.DashboardSection', []).directive('dashboardSection', DashboardSection.Factory());
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=dashboard-section.js.map
var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            'use strict';
            var DashboardColumnController = (function () {
                function DashboardColumnController() {
                }
                DashboardColumnController.prototype.getDashboardColumnStyle = function () {
                    if (this.dashboardColumnSize && this.dashboardColumnSize.length > 0) {
                        if (this.dashboardColumnSize === 'sm' ||
                            this.dashboardColumnSize === 'small') {
                            return 'bm-widget-layout-column-sm';
                        }
                        if (this.dashboardColumnSize === 'hf' ||
                            this.dashboardColumnSize === 'half') {
                            return 'bm-widget-layout-column-half';
                        }
                        if (this.dashboardColumnSize === 'med' ||
                            this.dashboardColumnSize === 'medium') {
                            return 'bm-widget-layout-column-med';
                        }
                        if (this.dashboardColumnSize === 'lg' ||
                            this.dashboardColumnSize === 'large') {
                            return 'bm-widget-layout-column-lg';
                        }
                    }
                    return 'bm-widget-layout-column';
                };
                return DashboardColumnController;
            }());
            dashboard.DashboardColumnController = DashboardColumnController;
            var DashboardColumn = (function () {
                function DashboardColumn($compile, $timeout, $translate) {
                    this.$compile = $compile;
                    this.$timeout = $timeout;
                    this.$translate = $translate;
                    this.templateUrl = 'src/dashboards/dashboard/dashboard-column.html';
                    this.restrict = 'E';
                    this.transclude = true;
                    this.replace = true;
                    this.bindToController = true;
                    this.controller = DashboardColumnController;
                    this.controllerAs = 'dbcCtrl';
                    this.scope = {
                        'dashboardColumnSize': '@'
                    };
                }
                DashboardColumn.Factory = function () {
                    var directive = function ($compile, $timeout, $translate) {
                        return new DashboardColumn($compile, $timeout, $translate);
                    };
                    directive['$inject'] = ['$compile', '$timeout', '$translate'];
                    return directive;
                };
                return DashboardColumn;
            }());
            dashboard.DashboardColumn = DashboardColumn;
            angular.module('bm.core.dashboard.DashboardColumn', []).directive('dashboardColumn', DashboardColumn.Factory());
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=dashboard-column.js.map
var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            var Components;
            (function (Components) {
                'use strict';
                var NotificationsController = (function () {
                    function NotificationsController(notificationsManager, $translate, bmTranslateEventUtils, $uibModal) {
                        this.notificationsManager = notificationsManager;
                        this.$translate = $translate;
                        this.bmTranslateEventUtils = bmTranslateEventUtils;
                        this.$uibModal = $uibModal;
                        this.notifications = new Array();
                        this.notificationLimit = 5;
                        if (this.currentClient && this.currentClient.id) {
                            notificationsManager.clientId = this.currentClient.id;
                        }
                    }
                    NotificationsController.prototype.$onChanges = function (changes) {
                        if (changes.currentClient.currentValue) {
                            this.notificationsManager.clientId = this.currentClient.id;
                            this.allNotificationsTitle =
                                this.$translate.instant('BlueMoon.Accounting.Components.Notifications') +
                                    ' - ' +
                                    this.currentClient.name;
                            this.reloadNotifications();
                        }
                    };
                    NotificationsController.prototype.reloadNotifications = function () {
                        var _this = this;
                        this.notificationsManager.getNotificationList(1, 100)
                            .then(function (result) {
                            if (result && result.items.length > 0) {
                                _this.notifications = result.items;
                            }
                            else {
                                var fake = new Components.OnvioNotification();
                                fake.onvioNotificationText = _this.notificationsManager.noNotificationText;
                                _this.notifications = new Array();
                                _this.notifications.push(fake);
                            }
                        });
                    };
                    NotificationsController.prototype.showAllNotifications = function () {
                        var options = {
                            backdrop: 'static',
                            templateUrl: 'src/dashboards/notifications/all-notifications.html',
                            resolve: {
                                notificationsController: this
                            },
                            controller: 'notificationsDialogController as $ctrl'
                        };
                        this.$uibModal.open(options);
                    };
                    return NotificationsController;
                }());
                NotificationsController.$inject = ['notificationsManager', '$translate', 'bmTranslateEventUtils', '$uibModal'];
                Components.NotificationsController = NotificationsController;
                var NotificationsDialogController = (function () {
                    function NotificationsDialogController($scope, $window, $translate, $q, $uibModalInstance, $bentoBusyLoader, notificationsController, notificationsManager) {
                        this.$scope = $scope;
                        this.$window = $window;
                        this.$translate = $translate;
                        this.$q = $q;
                        this.$uibModalInstance = $uibModalInstance;
                        this.$bentoBusyLoader = $bentoBusyLoader;
                        this.notificationsController = notificationsController;
                        this.notificationsManager = notificationsManager;
                        var ctrl = this;
                        ctrl.$scope.$on('$locationChangeStart', function () {
                            ctrl.onCancel();
                        });
                    }
                    NotificationsDialogController.prototype.onClose = function () {
                        this.$uibModalInstance.dismiss('close');
                    };
                    NotificationsDialogController.prototype.onCancel = function () {
                        this.$uibModalInstance.dismiss('cancel');
                    };
                    NotificationsDialogController.prototype.deleteAll = function () {
                        var _this = this;
                        var confirmed = this.$window.confirm(this.$translate.instant('Bluemoon.Dashboards.Components.DeleteAllNotificationConfirmation'));
                        if (confirmed) {
                            var promises = [];
                            var loader = this.$bentoBusyLoader.getNewLoader(this.$uibModalInstance);
                            loader.show();
                            while (this.notificationsController.notifications.length > 0) {
                                promises.push(this.notificationsManager.deleteNotification(this.notificationsController.notifications.pop()));
                            }
                            this.$q.all(promises).then(function () {
                                _this.notificationsController.reloadNotifications();
                                loader.hide();
                            });
                        }
                    };
                    return NotificationsDialogController;
                }());
                NotificationsDialogController.$inject = [
                    '$scope',
                    '$window',
                    '$translate',
                    '$q',
                    '$uibModalInstance',
                    '$bentoBusyLoader',
                    'notificationsController',
                    'notificationsManager'
                ];
                Components.NotificationsDialogController = NotificationsDialogController;
                var Notifications = (function () {
                    function Notifications() {
                        this.bindings = {
                            currentClient: '<'
                        };
                        this.controller = NotificationsController;
                        this.templateUrl = 'src/dashboards/notifications/notifications.html';
                    }
                    return Notifications;
                }());
                Components.Notifications = Notifications;
                angular.module('bm.core.dashboard.components.Notifications', ['ui.bootstrap.modal'])
                    .component('notifications', new Notifications())
                    .controller('notificationsController', NotificationsController)
                    .controller('notificationsDialogController', NotificationsDialogController);
            })(Components = dashboard.Components || (dashboard.Components = {}));
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=notifications.js.map
var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            var Components;
            (function (Components) {
                'use strict';
                var NotificationController = (function () {
                    function NotificationController(notificationsManager) {
                        this.notificationsManager = notificationsManager;
                    }
                    NotificationController.prototype.getIconClass = function () {
                        var iconClass = 'bento-icon-info';
                        return iconClass;
                    };
                    NotificationController.prototype.getNotificationClass = function () {
                        var notificationClass = 'bmdc-notification-information';
                        return notificationClass;
                    };
                    NotificationController.prototype.getNotificationText = function () {
                        var notificationText = this.onvioNotification.onvioNotificationText;
                        notificationText = notificationText.trim();
                        return notificationText;
                    };
                    NotificationController.prototype.getTimeElapsed = function () {
                        if (moment) {
                            return moment.utc(this.onvioNotification.timestamp).fromNow();
                        }
                        return new Date(this.onvioNotification.timestamp).toDateString();
                    };
                    NotificationController.prototype.deleteNotification = function () {
                        var _this = this;
                        if (this.onvioNotification) {
                            this.notificationsManager.deleteNotification(this.onvioNotification).then(function () {
                                if (_this.parentRefresh) {
                                    _this.parentRefresh();
                                }
                            });
                        }
                    };
                    NotificationController.prototype.isFakeNotification = function () {
                        return this.onvioNotification.onvioNotificationText === this.notificationsManager.noNotificationText;
                    };
                    return NotificationController;
                }());
                NotificationController.$inject = ['notificationsManager'];
                Components.NotificationController = NotificationController;
                var Notification = (function () {
                    function Notification() {
                        this.bindings = {
                            onvioNotification: '<',
                            parentRefresh: '&'
                        };
                        this.controller = NotificationController;
                        this.templateUrl = 'src/dashboards/notifications/notification.html';
                    }
                    return Notification;
                }());
                Components.Notification = Notification;
                angular.module('bm.core.dashboard.components.Notification', []).component('notification', new Notification());
            })(Components = dashboard.Components || (dashboard.Components = {}));
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=notification.js.map
var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            var Components;
            (function (Components) {
                'use strict';
                var OnvioNotification = (function () {
                    function OnvioNotification() {
                    }
                    return OnvioNotification;
                }());
                Components.OnvioNotification = OnvioNotification;
                var PagedStoredNotifications = (function () {
                    function PagedStoredNotifications() {
                    }
                    return PagedStoredNotifications;
                }());
                Components.PagedStoredNotifications = PagedStoredNotifications;
                var NotificationsManager = (function () {
                    function NotificationsManager($http, $translate, bmHttpUtils) {
                        this.$http = $http;
                        this.$translate = $translate;
                        this.bmHttpUtils = bmHttpUtils;
                        this.api = '/api/notifications/v1/notifications';
                        this.defaultPageNumber = 1;
                        this.defaultItemsPerPage = 20;
                        this.noNotificationText = this.$translate.instant('BlueMoon.Dashboard.Components.NoNotifications');
                    }
                    NotificationsManager.prototype.getNotificationList = function (pageNumber, itemsPerPage) {
                        if (angular.isUndefined(pageNumber)) {
                            pageNumber = this.defaultPageNumber;
                        }
                        if (angular.isUndefined(itemsPerPage)) {
                            itemsPerPage = this.defaultItemsPerPage;
                        }
                        var messageTags = encodeURIComponent('{"clientIdTag":"' + this.clientId + '"}');
                        var httpConfig = {
                            method: 'GET',
                            url: this.api + '?types=direct&itemsPerPage=' + itemsPerPage + '&pageNumber=' + pageNumber +
                                (this.clientId !== '' ? ('&messageTags=' + messageTags) : '')
                        };
                        return this.bmHttpUtils.unwrapAndValidateHttpPromise(null, this.$http(httpConfig), true);
                    };
                    NotificationsManager.prototype.deleteNotification = function (notification) {
                        return this.$http({
                            method: 'DELETE',
                            url: this.api + '/' + notification.id
                        }).then(function (response) { return response; });
                    };
                    return NotificationsManager;
                }());
                NotificationsManager.$inject = [
                    '$http',
                    '$translate',
                    'bmHttpUtils'
                ];
                Components.NotificationsManager = NotificationsManager;
                angular.module('bm.core.dashboard.components.NotificationsManager', [])
                    .service('notificationsManager', NotificationsManager);
            })(Components = dashboard.Components || (dashboard.Components = {}));
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=notification-manager.js.map
angular.module('bm.core.dashboard.components.templates', ['src/dashboards/dashboard/dashboard-column.html', 'src/dashboards/dashboard/dashboard-section.html', 'src/dashboards/dashboard/dashboard-widget.html', 'src/dashboards/dashboard/dashboard.html', 'src/dashboards/notifications/all-notifications.html', 'src/dashboards/notifications/notification.html', 'src/dashboards/notifications/notifications.html']);

angular.module("src/dashboards/dashboard/dashboard-column.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("src/dashboards/dashboard/dashboard-column.html",
    "<div class=\"bm-dashboard-column-content {{dbcCtrl.getDashboardColumnStyle()}}\" ng-transclude>\n" +
    "</div>");
}]);

angular.module("src/dashboards/dashboard/dashboard-section.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("src/dashboards/dashboard/dashboard-section.html",
    "<section class=\"bm-widget-section\">\n" +
    "	<header ng-show=\"dbsCtrl.dashboardSectionTitle\">\n" +
    "		<h2 class=\"bm-widget-section\">{{dbsCtrl.dashboardSectionTitle}}</h2>\n" +
    "	</header>\n" +
    "	<div class=\"bm-widget-layout\" ng-transclude>\n" +
    "	</div>\n" +
    "</section>\n" +
    "");
}]);

angular.module("src/dashboards/dashboard/dashboard-widget.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("src/dashboards/dashboard/dashboard-widget.html",
    "<article class=\"bm-widget\">\n" +
    "	<header ng-show=\"dbwCtrl.dashboardWidgetTitle\">\n" +
    "		<h2 class=\"bm-widget-title\">{{dbwCtrl.dashboardWidgetTitle}}</h2>\n" +
    "	</header>\n" +
    "	<div class=\"bm-widget-body\" ng-transclude>\n" +
    "	</div>\n" +
    "</article>\n" +
    "");
}]);

angular.module("src/dashboards/dashboard/dashboard.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("src/dashboards/dashboard/dashboard.html",
    "<section class=\"bm-widget-dashboard\">\n" +
    "	<header ng-show=\"dbCtrl.dashboardTitle\">\n" +
    "		<h1 class=\"bm-widget-dashboard-title\">{{dbCtrl.dashboardTitle}}</h1>\n" +
    "	</header>\n" +
    "	<div  ng-transclude></div>\n" +
    "</section>");
}]);

angular.module("src/dashboards/notifications/all-notifications.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("src/dashboards/notifications/all-notifications.html",
    "<div class=\"bmdc-all-notifications\">\n" +
    "	<div class=\"bmdc-all-notifications-header bmdc-flex-row\">\n" +
    "		<div class=\"bmdc-all-notifications-title\">{{$ctrl.notificationsController.allNotificationsTitle}}</div>\n" +
    "		<div class=\"bmdc-all-notifications-x\"><a class=\"bento-icon-close-x\" ng-click=\"$ctrl.onClose()\"></a></div>\n" +
    "	</div>\n" +
    "	<div class=\"bmdc-all-notifications-toolbar bmdc-flex-row\">\n" +
    "		<div class=\"bmdc-all-notifications-delete-all\">\n" +
    "			<a ng-click=\"$ctrl.deleteAll()\" translate>BlueMoon.Accounting.Components.DeleteAll</a>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"bmdc-flex-column bmdc-all-notifications-scoll-area\">\n" +
    "		<notification ng-repeat=\"notification in $ctrl.notificationsController.notifications\" onvio-notification=\"notification\" parent-refresh=\"$ctrl.notificationsController.reloadNotifications()\">\n" +
    "		</notification>\n" +
    "	</div>\n" +
    "	<div class=\"bmdc-flex-row bmdc-all-notifications-footer\">\n" +
    "		<button class=\"btn btn-default btn-dynamic\" ng-click=\"$ctrl.onClose()\" translate>BlueMoon.Accounting.Components.Close</button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("src/dashboards/notifications/notification.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("src/dashboards/notifications/notification.html",
    "<div class=\"bmdc-notification bmdc-flex-row\">\n" +
    "	<div class=\"{{$ctrl.getNotificationClass()}} bmdc-notification-type-icon bmdc-flex-column\">\n" +
    "		<i class=\"{{$ctrl.getIconClass()}}\"></i>\n" +
    "	</div>\n" +
    "	<div class=\"bmdc-notification-body bmdc-flex-column\">\n" +
    "		<div ng-bind-html=\"$ctrl.getNotificationText()\"></div>\n" +
    "	</div>\n" +
    "	<div class=\"bmdc-notification-elapsed bmdc-flex-column\" ng-hide=\"$ctrl.isFakeNotification()\">\n" +
    "		{{$ctrl.getTimeElapsed()}}\n" +
    "	</div>\n" +
    "	<div class=\"bmdc-notification-button bmdc-flex-column\" ng-hide=\"$ctrl.isFakeNotification()\">\n" +
    "		<a class=\"bento-icon-close-x\" ng-click=\"$ctrl.deleteNotification()\"></a>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("src/dashboards/notifications/notifications.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("src/dashboards/notifications/notifications.html",
    "<div class=\"bmdc-notification-container\"\n" +
    "     bento-busy-loader=\"$ctrl.notifications.length === 0\"\n" +
    "     bento-busy-loader-size=\"small\">\n" +
    "	<div class=\"bmdc-notifications-component\"\n" +
    "	     ng-show=\"$ctrl.notifications.length > 0\">\n" +
    "		<div class=\"bmdc-notifications-component-notifications-wrapper\">\n" +
    "			<notification ng-repeat=\"notification in $ctrl.notifications | limitTo:$ctrl.notificationLimit\"\n" +
    "			              onvio-notification=\"notification\"\n" +
    "			              parent-refresh=\"$ctrl.reloadNotifications()\">\n" +
    "			</notification>\n" +
    "		</div>\n" +
    "		<footer class=\"bmdc-show-all-notifications\"\n" +
    "		        ng-show=\"$ctrl.notifications.length > $ctrl.notificationLimit\">\n" +
    "			<a class=\"\"\n" +
    "			   ng-click=\"$ctrl.showAllNotifications()\">{{'Bluemoon.Accounting.Components.ShowAllNotifications' | translate}}\n" +
    "				({{$ctrl.notifications.length}})</a>\n" +
    "		</footer>\n" +
    "	</div>\n" +
    "</div>");
}]);

var bm;
(function (bm) {
    var core;
    (function (core) {
        var dashboard;
        (function (dashboard) {
            'use strict';
            angular.module('bm.core.dashboard.components.DashboardComponents', [
                'bm.core.dashboard.Dashboard',
                'bm.core.dashboard.DashboardWidget',
                'bm.core.dashboard.DashboardSection',
                'bm.core.dashboard.DashboardColumn',
                'bm.core.dashboard.components.Notifications',
                'bm.core.dashboard.components.Notification',
                'bm.core.dashboard.components.NotificationsManager',
                'bm.core.dashboard.components.templates'
            ]);
        })(dashboard = core.dashboard || (core.dashboard = {}));
    })(core = bm.core || (bm.core = {}));
})(bm || (bm = {}));
//# sourceMappingURL=components.js.map